import { ValueUpdater } from '../../../../valueUpdater';
export class DefectV11 {
    static constructFromPlainObject(sourceDefect) {
        const defect = new DefectV11(sourceDefect.code, sourceDefect.description, sourceDefect.type);
        defect.positionNumber = ValueUpdater.updateNullableField(defect.positionNumber, sourceDefect.positionNumber);
        defect.isSelected = ValueUpdater.updateNonNullableField(defect.isSelected, sourceDefect.isSelected);
        return defect;
    }
    constructor(code, description, type) {
        this.code = code;
        this.description = description;
        this.type = type;
        this.positionNumber = null;
        this.isSelected = false;
    }
    getCode() {
        return this.code;
    }
    getDescription() {
        return this.description;
    }
    getType() {
        return this.type;
    }
    getPositionNumber() {
        return this.positionNumber;
    }
    setPositionNumber(positionNumber) {
        this.positionNumber = positionNumber;
    }
    getIsSelected() {
        return this.isSelected;
    }
    setIsSelected(isSelected) {
        this.isSelected = isSelected;
    }
}
//# sourceMappingURL=defectV11.js.map